import React, { useMemo, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import {
  downloadBalanceReport as downloadBalanceReportAction,
  downloadBookingReport as downloadBookingReportAction,
  downloadInvoices,
  getBookingList,
  resendInvoiceAction,
} from "../../../redux/actions/pvs"
import { Button, Label } from "reactstrap"
import RefreshButton from "components/RefreshButton/RefreshButton"
import { toast } from "react-toastify"
import {
  DOWNLOAD_BALANCE_REPORT_RESET,
  DOWNLOAD_BOOKING_REPORT_RESET,
  DOWNLOAD_INVOICES_RESET,
  RESEND_INVOICE_RESET,
} from "../../../redux/types/pvs"
import ActionDropdown from "components/ActionDropdown"

const useQuery = () => new URLSearchParams(useLocation().search)

const ViewBookingList = () => {
  document.title = "PULA Bazaar List"

  const query = useQuery()
  const bazaarId = query.get("id")

  const history = useNavigate()
  const dispatch = useDispatch()

  const token = useSelector(state => state.auth.token)
  const paymentStatistics = useSelector(state => state.pvs.paymentStatistics)
  const bazaarListState = useSelector(state => state.pvs.bazaarList)
  const bookingList = useSelector(state => state.pvs.bookingList)
  const invoicesZipFileLink = useSelector(
    state => state.pvs.invoicesZipFileLink
  )
  const bookingReportFileLink = useSelector(
    state => state.pvs.bookingReportFileLink
  )
  const balanceReportFileLink = useSelector(
    state => state.pvs.balanceReportFileLink
  )
  const resendInvoiceScreen = useSelector(
    state => state.screens.pvs.resendInvoice
  )
  const downloadInvoicesScreen = useSelector(
    state => state.screens.pvs.downloadInvoices
  )
  const downloadBookingReportScreen = useSelector(
    state => state.screens.pvs.downloadBookingReport
  )
  const downloadBalanceReportScreen = useSelector(
    state => state.screens.pvs.downloadBalanceReport
  )

  console.log("bookingList", bookingList)
  const [userData, setUserData] = useState([])

  // 🔹 Fetch live booking list
  useEffect(() => {
    dispatch(getBookingList({ bazaar_id: bazaarId }, token))
  }, [])

  // 🔹 Update local data once Redux updates
  useEffect(() => {
    setUserData(bookingList)
  }, [bookingList])

  useEffect(() => {
    if (resendInvoiceScreen.success) {
      toast.success(resendInvoiceScreen.message)
      dispatch({ type: RESEND_INVOICE_RESET })
    }
    if (resendInvoiceScreen.error) {
      toast.error(resendInvoiceScreen.error)
      dispatch({ type: RESEND_INVOICE_RESET })
    }
  }, [resendInvoiceScreen])

  useEffect(() => {
    if (downloadInvoicesScreen.success) {
      toast.success(downloadInvoicesScreen.message)

      if (invoicesZipFileLink) {
        const link = document.createElement("a")
        link.href = invoicesZipFileLink
        link.download = "invoices.zip"
        link.click()
      }
      dispatch({ type: DOWNLOAD_INVOICES_RESET })
    }
    if (downloadInvoicesScreen.error) {
      toast.error(downloadInvoicesScreen.error)
      dispatch({ type: DOWNLOAD_INVOICES_RESET })
    }
  }, [downloadInvoicesScreen])

  useEffect(() => {
    if (downloadBookingReportScreen.success) {
      if (bookingReportFileLink) {
        const link = document.createElement("a")
        link.href = bookingReportFileLink
        link.download = "booking-report.zip"
        link.click()
      }
      dispatch({ type: DOWNLOAD_BOOKING_REPORT_RESET })
    }
    if (downloadBookingReportScreen.error) {
      toast.error(downloadBookingReportScreen.error)
      dispatch({ type: DOWNLOAD_BOOKING_REPORT_RESET })
    }
  }, [downloadBookingReportScreen])

  useEffect(() => {
    if (downloadBalanceReportScreen.success) {
      if (balanceReportFileLink) {
        const link = document.createElement("a")
        link.href = balanceReportFileLink
        link.download = "balance-report.zip"
        link.click()
      }
      dispatch({ type: DOWNLOAD_BALANCE_REPORT_RESET })
    }
    if (downloadBalanceReportScreen.error) {
      toast.error(downloadBalanceReportScreen.error)
      dispatch({ type: DOWNLOAD_BALANCE_REPORT_RESET })
    }
  }, [downloadBalanceReportScreen])

  const resendInvoice = registrationId => {
    dispatch(
      resendInvoiceAction({ enc_bazaar_register_id: registrationId }, token)
    )
  }

  const downloadInvoice = () => {
    dispatch(downloadInvoices({ enc_bazaar_id: bazaarId }, token))
  }

  const handleDownloadBookingReport = () => {
    console.log("handleDownloadBookingReport invoked..")

    const bazaar = bazaarListState.find(b => b.enc_bazaar_id === bazaarId)
    console.log("bazaar", bazaar)

    const paymentStatistic = paymentStatistics.find(
      p => p.combine_group_id === bazaar.combine_group_id
    )
    console.log("paymentStatistic", paymentStatistic)

    dispatch(
      downloadBookingReportAction(
        {
          enc_combine_group_id: paymentStatistic.enc_combine_group_id,
          report_type: "excel", //list , excel
        },
        token
      )
    )
  }

  const handleDownloadBalanceReport = () => {
    const bazaar = bazaarListState.find(b => b.enc_bazaar_id === bazaarId)
    const paymentStatistic = paymentStatistics.find(
      p => p.combine_group_id === bazaar.combine_group_id
    )
    dispatch(
      downloadBalanceReportAction(
        {
          enc_combine_group_id: paymentStatistic.enc_combine_group_id,
          report_type: "excel", //list , excel
        },
        token
      )
    )
  }

  const columns = useMemo(
    () => [
      {
        header: "Seller Name",
        accessorKey: "seller_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      // {
      //   header: "Bazaar Name",
      //   accessorKey: "bazaar_name",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: "Booking Date",
      //   accessorKey: "created_at",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      {
        header: "Stall No",
        accessorKey: "stall_details",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Stall Type",
        accessorKey: "stall_category",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total",
        accessorKey: "payable_amount",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Paid",
        accessorKey: "paid_amount",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Due",
        accessorKey: "due_amount",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Invoice No",
        accessorKey: "invoice_no",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Payment Status",
        accessorKey: "payment_status",
        enableColumnFilter: false,
        enableSorting: true,
        sortingFn: (rowA, rowB, columnId) => {
          const order = {
            pending: 0,
            paid: 1,
            cancelled: 2,
          }

          const a = String(rowA.getValue(columnId) || "").toLowerCase()
          const b = String(rowB.getValue(columnId) || "").toLowerCase()

          const aRank = order[a] !== undefined ? order[a] : 99
          const bRank = order[b] !== undefined ? order[b] : 99

          return aRank - bRank
        },
        cell: info => {
          const status = info.getValue()
          return (
            <span
              className={`badge ${
                status === "Paid"
                  ? "bg-success"
                  : status === "Pending"
                  ? "bg-warning"
                  : "bg-danger"
              }`}
            >
              {status}
            </span>
          )
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const row = info.row.original
          // console.log('row..', row.payment_status?.toLowerCase());

          const paymentStatus =
            row && row.payment_status
              ? String(row.payment_status).toLowerCase()
              : ""

          const isPaid =
            paymentStatus === "paid" || paymentStatus === "cancelled"

          return (
            <div>
              {isPaid ? (
                row.invoice_link ? (
                  <>
                    <ActionDropdown buttonLabel="Invoice">
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          // const link = document.createElement("a")
                          // link.href = row.invoice_link
                          // link.download = "invoice.pdf"
                          // link.click()
                          window.open(row.invoice_link, "_blank")
                        }}
                      >
                        Download PDF
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() =>
                          resendInvoice(row.enc_bazaar_register_id)
                        }
                      >
                        Resend to user
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() =>
                          history(`/invoice-action/update`, {
                            state: {
                              type: "update",
                              id: row.enc_bazaar_register_id,
                            },
                          })
                        }
                      >
                        Update Data
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() =>
                          history(`/invoice-action/regenerate`, {
                            state: {
                              type: "cancel_and_regenerate",
                              id: row.enc_bazaar_register_id,
                            },
                          })
                        }
                      >
                        Cancel & Regenrate
                      </button>
                    </ActionDropdown>
                  </>
                ) : (
                  <></> // isPaid true but no invoice → show empty
                )
              ) : (
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() =>
                    history(
                      `/add-bazaar-payment?id=${row.enc_bazaar_register_id}`
                    )
                  }
                  title="Add Payment"
                >
                  Add Payment
                </button>
              )}
            </div>
          )
        },
      },
    ],
    [history]
  )
  const handleRefresh = () => {
    dispatch(getBookingList({ bazaar_id: bazaarId }, token))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between my-4">
          <div>
            <h2 className="h4 mb-0 nom-title">
              {(userData && userData[0] && userData[0].bazaar_name) || ""}
            </h2>
          </div>
          <Button color="primary" onClick={downloadInvoice}>
            Download Invoices
          </Button>
          {/* <ActionDropdown
            buttonLabel="Download"
            className="btn btn-medium btn-primary me-2"
          >
            <button className="dropdown-item" onClick={downloadInvoice}>
              All Invoices
            </button>

            <button
              className="dropdown-item"
              onClick={handleDownloadBookingReport}
            >
              Booking Report
            </button>

            <button
              className="dropdown-item"
              onClick={handleDownloadBalanceReport}
            >
              Balance Report
            </button>
          </ActionDropdown> */}
          {/* <RefreshButton onRefresh={handleRefresh} /> */}
        </div>

        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={userData || []}
          initialSorting={[{ id: "payment_status", desc: false }]}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4 nominee-tbl-wrapper"
        />
      </div>
    </div>
  )
}

export default ViewBookingList
